import axios from 'axios'
import fileSaver from 'file-saver'
import moment from 'moment'

const sales = {
  state: {
    salesList: {
      data: [],
      timestamp: moment().unix()
    },
    salesTimestamp: moment().unix(),
    billingTimestamp: moment().unix()
  },
  mutations: {
    SET_SALES_LIST (state, list) {
      state.salesList.data = list
      state.salesList.timestamp = moment().unix()
    },
    SET_BILLING_TIMESTAMP (state) {
      state.billingTimestamp = moment().unix()
    },
    REMOVE_SALES_DATA (state) {
      state.salesList = {
        data: [],
        timestamp: moment().unix()
      }
    }
  },
  actions: {
    fetchSales ({commit, getters}, {params}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/reports')
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchChartSource ({commit, getters}, {params}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/reports/chart', {params: params})
          .then(response => {
            // commit('SET_SALES_LIST', response.data.dataSets.chartSource)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchTableSource ({commit, getters}, {params}) {
      return new Promise((resolve, reject) => {
        let type = params.type
        delete params['type']
        axios.get('/api/v1/reports/table/' + type, {params: params})
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    downloadSales ({commit}, {params}) {
      return new Promise((resolve, reject) => {
        let type = params.type
        delete params['type']
        let start = moment(params.startTime).format('YYYY-MM-DD').replace(/-/g, '/')
        let end = moment(params.endTime).format('YYYY-MM-DD').replace(/-/g, '/')
        let filePrefix = (start === end) ? start : start + '_' + end
        let downloadType = (params.exportFormat === 'excel') ? 'xlsx' : 'csv'
        var instance = axios.create({
          responseType: 'arraybuffer'
        })
        instance.get('/api/v1/reports/table/' + type + '/download', {params: params})
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/octet-stream'})
            fileSaver.saveAs(blob, filePrefix.replace(/\//g, '') + '_中華金資交易明細.' + downloadType)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchBillingSource ({commit, getters}, {params}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/v1/reports/table/billing', {params: params})
          .then(response => {
            commit('SET_BILLING_TIMESTAMP')
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    downloadBilling ({commit}, {params}) {
      return new Promise((resolve, reject) => {
        let start = moment(params.startTime).format('YYYY-MM-DD').replace(/-/g, '/')
        let end = moment(params.endTime).format('YYYY-MM-DD').replace(/-/g, '/')
        let filePrefix = (start === end) ? start : start + '_' + end
        let downloadType = (params.exportFormat === 'excel') ? 'xlsx' : 'csv'
        var instance = axios.create({
          responseType: 'arraybuffer'
        })
        instance.get('/api/v1/reports/table/billing/download', {params: params})
          .then(response => {
            let blob = new Blob([response.data], {type: 'application/octet-stream'})
            fileSaver.saveAs(blob, filePrefix.replace(/\//g, '') + '_中華金資帳務明細.' + downloadType)
            resolve()
          })
          .catch(error => {
            reject(error)
          })
      })
    }
  },
  getters: {
    getSales (state) {
      return state.salesList.data
    },
    getSalesTime (state) {
      return state.salesList.timestamp
    },
    getBillingTime (state) {
      return state.billingTimestamp
    }
  }
}

export default sales
